// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__5gGWm","detailsBorder":"styles_detailsBorder__3iEsx"};